import { useLang } from "../../App";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="py-16 bg-[#040813] text-slate-400" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-8 pb-12 border-b border-slate-800">
          <div>
            <div className="disp text-2xl font-black text-white mb-2">
              <span className="text-[#fbbf24]">i</span>Credit
            </div>
            <p className="text-xs text-slate-400 leading-relaxed mb-4">{t("footer.tagline")}</p>
            <span className="mono text-[10px] uppercase text-[#fbbf24] px-2 py-1 bg-[#fbbf24]/10 rounded border border-[#fbbf24]/30">
              TRUSTED SINCE 2015
            </span>
          </div>
          <div>
            <h4 className="mono text-xs uppercase tracking-widest text-white mb-3">{t("footer.contacts")}</h4>
            <ul className="mono text-xs space-y-2">
              <li>{t("footer.phone")} <span className="text-white" data-testid="footer-phone">011-3335-7865 (Admin)</span></li>
              <li>{t("footer.email")} <span className="text-white" data-testid="footer-email">icreditcompany816@gmail.com</span></li>
              <li>{t("footer.hours")}</li>
            </ul>
          </div>
          <div>
            <h4 className="mono text-xs uppercase tracking-widest text-white mb-3">{t("footer.products")}</h4>
            <ul className="text-xs space-y-2">
              <li>{t("footer.pl")}</li>
              <li>{t("footer.bl")}</li>
              <li>{t("footer.ceiling")}</li>
            </ul>
          </div>
        </div>
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between text-xs mono text-slate-400">
          <p>{t("footer.rights")}</p>
          <p>{t("footer.wa")}</p>
        </div>
      </div>
    </footer>
  );
};
